// @ts-nocheck
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';

// Section components (we will gradually migrate/replace these)
import Dashboard from './components/sections/Home/Home';
import TodoList from './components/sections/TodoTS/TodoList';
import TaskList from './components/sections/Tasks/TaskList';
import Ideas from './components/sections/Ideas/index';
import Notebooks from './components/sections/Notebooks/Notebooks';
import WebLinks from './components/sections/WebLinks/WebLinks';
import DecisionTree from './components/sections/Decisions/DecisionTree';
import TagManager from './components/tags/TagManager';
import Journal from './components/sections/Journal/Journal';
import ProjectDetails from './components/sections/Projects/ProjectDetails';
import Projects from './components/sections/Projects';
import SettingsPage from './components/sections/Settings/SettingsPage';
import EmailSection from './components/sections/Email/Email';
import ChatSection from './components/sections/Chat/Chat';
import AddAccount from './components/sections/Email/AddAccount';
import GroupsPage from './components/sections/Groups/GroupsPage';
import GroupDashboard from './components/sections/Groups/GroupDashboard';

const MainApp = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/ideas" element={<Ideas />} />
        <Route path="/todo" element={<TodoList />} />
        <Route path="/tasks" element={<TaskList />} />
        <Route path="/notebooks" element={<Notebooks />} />
        <Route path="/weblinks" element={<WebLinks />} />
        <Route path="/decisions" element={<DecisionTree />} />
        <Route path="/tags" element={<TagManager />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/projects/:projectId" element={<ProjectDetails />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/groups/:groupId" element={<GroupDashboard />} />
        <Route path="/email" element={<EmailSection />} />
        <Route path="/email/add" element={<AddAccount />} />
        <Route path="/email/:accountId" element={<EmailSection />} />
        <Route path="/chat" element={<ChatSection />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

export default MainApp; 